import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IMenuItem } from '../../models/menu.model';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent {
  @Input() menuItemList: IMenuItem[];
  @Output() supportClicked = new EventEmitter<void>();
}
